var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 386",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-solid",
    transform: "translate(0.000000, 0.925000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.6,214.675 C451.1,202.175 451.1,181.875 438.6,169.375 L278.6,9.375 C266.1,-3.125 245.8,-3.125 233.3,9.375 C220.8,21.875 220.8,42.175 233.3,54.675 L338.8,160.075 L32,160.075 C14.3,160.075 0,174.375 0,192.075 C0,209.775 14.3,224.075 32,224.075 L338.7,224.075 L233.4,329.475 C220.9,341.975 220.9,362.275 233.4,374.775 C245.9,387.275 266.2,387.275 278.7,374.775 L438.7,214.775 L438.6,214.675 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.343f63d14d67c240727912319671f134.svg";
export { ForwardRef as ReactComponent };